import { render } from "./BaseGeoTable.vue?vue&type=template&id=38ccacd9"
import script from "./BaseGeoTable.vue?vue&type=script&lang=js"
export * from "./BaseGeoTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__